import { required, useGetIdentity, useRecordContext } from "ra-core";
import { useController } from "react-hook-form";
import { BooleanInput } from "@/components/admin/boolean-input";
import { TextInput } from "@/components/admin/text-input";

import type { Sale, SaleRole } from "../types";

export const ROLE_OPTIONS: { value: SaleRole; label: string; color: string }[] = [
  { value: "admin",        label: "管理员（Admin）",    color: "bg-blue-100 text-blue-800" },
  { value: "manager",      label: "销售经理（Manager）", color: "bg-purple-100 text-purple-800" },
  { value: "sales",        label: "销售员（Sales）",     color: "bg-green-100 text-green-800" },
  { value: "merchandiser", label: "跟单员（Merchandiser）", color: "bg-orange-100 text-orange-800" },
  { value: "finance",      label: "财务（Finance）",     color: "bg-yellow-100 text-yellow-800" },
];

function RoleSelectField({ disabled }: { disabled: boolean }) {
  const { field } = useController({ name: "role", defaultValue: "sales" });
  return (
    <div className="space-y-1.5">
      <label className="text-sm font-medium leading-none">角色</label>
      <select
        {...field}
        disabled={disabled}
        className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
      >
        {ROLE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {disabled && (
        <p className="text-xs text-muted-foreground">无法修改自己的角色</p>
      )}
    </div>
  );
}

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const isSelf = record?.id === identity?.id;

  return (
    <div className="space-y-4 w-full">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" validate={required()} helperText={false} />
      <TextInput source="email" validate={[required()]} helperText={false} />
      <RoleSelectField disabled={isSelf} />
      <BooleanInput source="disabled" readOnly={isSelf} helperText={false} />
    </div>
  );
}
